import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/pages/cadastroFuncionario'

const initialState = {
  id: '',
  nome: '',
  cpf: '',
  dataNascimento: null,
  telefone: '',
  email: '',
  observacoes: '',
  endereco: {},
  matriculas: [],
  informacoesAdicionais: {},
  informacoesBancarias: []
}

export default (prevState, action) => {
  if (typeof prevState === 'undefined') return initialState

  const mergeState = R.mergeRight(prevState)

  const addIn = listName =>
    R.compose(mergeState, R.assoc(listName, R.__, []), R.append(R.__, R.prop(listName, prevState)))

  const updateMatricula = matricula => ({
    ...prevState,
    matriculas: prevState.matriculas.map(_m => {
      if (_m.id === matricula.id) return matricula
      return _m
    })
  })

  const removeMatricula = matricula => ({
    ...prevState,
    matriculas: prevState.matriculas.filter(_m => {
      return _m.id !== matricula
    })
  })

  switch (action.type) {
    case actionTypes.SET_FUNCIONARIO:
      return mergeState(action.funcionario)
    case actionTypes.ADD_MATRICULA:
      return addIn('matriculas')(action.matricula)
    case actionTypes.UPDATE_MATRICULA:
      return updateMatricula(action.matricula)
    case actionTypes.REMOVE_MATRICULA:
      return removeMatricula(action.matricula)
    case actionTypes.CLEAR_FUNCIONARIO:
      return initialState
    default:
      return prevState
  }
}
